<template>
    <div>
        <div v-if="filterEnable" id="accordionFilter" class="content">
            <div class="card">
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                     data-parent="#accordionFilter">
                    <div class="card-body">
                        <form>
                            <em-filter ref="emFilter" :entity="entity" :$_emCustomVuexMixin_filter="filterState"
                                       :with-pagination="false"
                                       :$_emCustomVuexMixin_vo="loadState" :queryApi="queryApi"
                                       filterCss="col-md-4"
                                       :queryPrepareMutation="queryPrepareMutation"
                                       @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                       @doClear="filterDoClear"></em-filter>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div id="entityResultTable" class="content">
            <div class="card my-1">
                <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                     data-parent="#accordionResult">
                    <div class="card-body" style="overflow-x:auto">
                        <em-z-tree ref="zTree"
                                   :treeNodes="filterEnable ? treeNodes : treeNodesBind"
                                   :nodeAppender="nodeAppender"
                                   :selectedId="selectedId"
                                   :textKeys="textKeys"
                                   :add-diy-dom="addDiyDom"
                                   :check-enable="checkEnable"
                                   :checked-ids="checkedIds"
                                   :chkbox-type="chxboxType"
                                   @onclick="nodeOnClick"></em-z-tree>
                        <div v-if="enableSwitchCheckRelated" class="position-absolute top right mt-1 mr-1">
                            <avatar-button :icon="currentIcon" v-b-toggle.collapse title="显示模式"></avatar-button>
                            <b-collapse id="collapse" class="mt-2">
                                <div class="d-flex flex-column">
                                    <avatar-button v-for="(item,index) of options" :key="index"
                                                   :icon="item.icon"
                                                   :title="item.label"
                                                   @btnClick="changeChxType(item)"></avatar-button>
                                </div>
                            </b-collapse>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author YuJiaBei
// Date 2020-07-09 15:09:42

import EmFilter from "@/components/em/EmFilter";
import EmZTree from "@/components/em/EmZTree";
import emCommonModalMixin from "@/mixin/em/common/modal";
import AvatarButton from "@/components/echarts-part/CalendarShift/cells/stuffs/AvatarButton";

export default {
    name: "emEntityTreeView",
    mixins: [emCommonModalMixin],
    components: {AvatarButton, EmFilter, EmZTree},
    props: {
        //启用filter
        filterEnable: {
            type: Boolean,
            default: false
        },
        entity: {
            type: String,
            request: true
        },
        filterState: {
            type: String,
            default: 'filter'
        },
        loadState: {
            type: String,
            default: 'rows'
        },
        queryApi: {
            type: String,
            default: 'findByFilter'
        },
        queryPrepareMutation: {
            type: String,
            default: ''
        },
        nodeAppender: {
            type: Function,
            default: null
        },
        addDiyDom: {
            type: Function,
            default: null
        },
        /**
         * 选中id，设置了该属性后，它只要发生变化，emZTree就会自动变更当前选中项
         */
        selectedId: {
            type: [String, Number],
            default: ""
        },
        /**
         * 插件的数据源
         */
        treeNodesBind: {
            type: Array
        },
        /**
         * 节点显示的text
         */
        textKeys: {
            type: String,
            default: "name"
        },
        /**
         * 是否启用多选框
         */
        checkEnable: {
            type: Boolean,
            default: false
        },
        enableSwitchCheckRelated: {
            type: Boolean,
            default: false
        },
        checkedIds: {
            type: String,
            default: ""
        }
    },
    computed: {
        treeNodes() {
            return this.$store.state[this.entity][this.loadState]
        }
    },
    data() {
        return {
            chxboxType: {"Y": "s", "N": "s"},
            currentIcon: 'el-icon-bottom-right',
            options: [
                {label: '关联父子', icon: 'el-icon-check', value: {"Y": "ps", "N": "ps"}},
                {label: '仅关联父', icon: 'el-icon-top-left', value: {"Y": "p", "N": "p"}},
                {label: '仅关联子', icon: 'el-icon-bottom-right', value: {"Y": "s", "N": "s"}},
                {label: '互不关联', icon: 'el-icon-close', value: {"Y": "", "N": ""}},
            ]
        }
    },
    // watch: {
    //   treeNodes() {
    //     console.log("watch: treeNodes change")
    //     console.log(this.treeNodes)
    //   }
    // },
    methods: {
        nodeOnClick(event, treeId, treeNode, clickFlag) {
            this.$emit("onclick", event, treeId, treeNode, clickFlag);
        },
        filterDoClear() {
            this.$emit("doClear");
        },
        getCheckedNodes() {
            return this.$refs.zTree.getCheckedNodes();
        },
        changeChxType(option) {
            this.chxboxType = option.value;
            this.currentIcon = option.icon;
        },
        doFilterQuery() {
            this.$refs.emFilter && this.$refs.emFilter.doQuery();
        }
    }
};
</script>